import { useEffect, useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import AppLogo from "../../assets/logotransparant.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { walletListAction } from "../../network/store/action/UserResponseAction";
import WalletItem from "./wallet-item";

function Wallet(){

    const navigate = useNavigate();
  const dispatch = useDispatch();

  // list of items
  const [resultList, setResultList] = useState([]);
  // progress Dialog
  const [isLoading, setIsLoading] = useState(false);

  const [filterList, setFilterList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const refreshTime = 60000; //How frequently you want to refresh the data, in ms


  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setResultList([]);
    setIsLoading(true);
    await dispatch(
      walletListAction(
        {
  
        },
        dispatch
      )
    ).then((reponse) => {
      setFilterList([]);
      setIsLoading(false);
      if (reponse.result) {
        setResultList(reponse.result);
      } else {
        setResultList([]);
      }
    });
  };

  return (
    <div className="row m-3">
          <div className="row m-3">
          <div className="row justify-content-around tble">
            <div className="col-6">
              <h3 className="dashboard-title">Wallet</h3>
            </div>
            <div className="mr-auto col-6 text-end">
             
            </div>
          </div>
        </div>
      <div className="col-md-12 card-1 table-responsive">
        <table className="table table-striped table-bordered border-sm  mt-2 align-middle">
          <thead className="thead-dark">
            <tr>
              <th scope="col">ID</th>
              <th scope="col">User Name</th>
              <th scope="col">Contact</th>
              <th scope="col">Wallet Amount</th>

            </tr>
          </thead>

          {searchVal === "" && resultList && resultList.length > 0 ? (
            <tbody>
              {resultList.map((item, i) => {
                return <WalletItem item={item} key={item.id} />;
              })}
            </tbody>
          ) : filterList.length > 0 ? (
            <tbody>
              {filterList.map((item, i) => {
                return <WalletItem item={item} key={item.id} />;
              })}
            </tbody>
          ) : isLoading ? (
            <p>Loading..</p>
          ) : (
            <p>No Data found</p>
          )}
        </table>
      </div>
    </div>
  );
}
export default Wallet;